import "./index.scss";

import Grid, { GridCol, GridRow } from "../Grid";

import Image from "components/atoms/Image";
import React from "react";
import { isExternal } from "utils/utils-common";

import "./index.scss";
import Link from "components/atoms/Link";

interface GridBannerPromotionProps {
  listBanner: Array<{
    image: string;
    alt: string;
    link: string;
  }>;
}

const GridBannerPromotion: React.FC<GridBannerPromotionProps> = (
  props: GridBannerPromotionProps,
) => {
  return (
    <div className="o-gridbannerpromotion">
      <Grid>
        <GridRow>
          {props.listBanner.length === 1 && (
            <GridCol>
              <Link href={props.listBanner[0].link}>
                <Image
                  src={props.listBanner[0].image}
                  alt={props.listBanner[0].alt}
                />
              </Link>
            </GridCol>
          )}
          {props.listBanner.length === 2 &&
            props.listBanner.map((item, key) => (
              <GridCol key={`${key}${item.image}`} colSm={12} colMd={6}>
                <Link href={item.link}>
                  <Image src={item.image} alt={item.alt} ratio={286 / 604} />
                </Link>
              </GridCol>
            ))}
          {props.listBanner.length === 3 && (
            <>
              <GridCol colSm={12} colMd={6}>
                <Link href={props.listBanner[0].link}>
                  <Image
                    src={props.listBanner[0].image}
                    alt={props.listBanner[0].alt}
                    ratio={1}
                  />
                </Link>
              </GridCol>
              <GridCol colSm={12} colMd={6}>
                <div className="o-gridbannerpromotion_group">
                  {props.listBanner.slice(1).map((item, key) =>
                    item.link === null ? (
                      <div className="a-link">
                        <Image
                          src={item.image}
                          alt={item.alt}
                          ratio={286 / 604}
                        />
                      </div>
                    ) : (
                      <Link
                        key={`${key}${item.image}`}
                        href={`${item.link}`}
                        isLinkRouter={!isExternal(item.link)}
                      >
                        <Image
                          src={item.image}
                          alt={item.alt}
                          ratio={286 / 604}
                        />
                      </Link>
                    ),
                  )}
                </div>
              </GridCol>
            </>
          )}
          {props.listBanner.length === 4 && (
            <>
              <GridCol colSm={12} colMd={6}>
                <Link href={props.listBanner[0].link}>
                  <Image
                    src={props.listBanner[0].image}
                    alt={props.listBanner[0].alt}
                    ratio={604 / 604}
                  />
                </Link>
              </GridCol>
              <GridCol colSm={12} colMd={6}>
                <Link href={props.listBanner[1].link}>
                  <Image
                    src={props.listBanner[1].image}
                    alt={props.listBanner[1].alt}
                    ratio={604 / 604}
                  />
                </Link>
              </GridCol>
              {props.listBanner.slice(2).map((item, key) => (
                <GridCol colSm={12} key={`${key}${item.image}`} colMd={6}>
                  <Link href={item.link}>
                    <Image src={item.image} alt={item.alt} ratio={286 / 604} />
                  </Link>
                </GridCol>
              ))}
            </>
          )}
          {props.listBanner.length > 4 && (
            <>
              <GridCol colSm={12} colMd={6}>
                <Link href={props.listBanner[0].link}>
                  <Image
                    src={props.listBanner[0].image}
                    alt={props.listBanner[0].alt}
                    ratio={1}
                  />
                </Link>
              </GridCol>
              <GridCol colSm={12} colMd={6}>
                <div className="o-gridbannerpromotion_group">
                  {props.listBanner.slice(1, 3).map((item, key) => (
                    <Link
                      key={`${key}${item.image}`}
                      href={`${item.link}`}
                      isLinkRouter={!isExternal(item.link)}
                    >
                      <Image
                        src={item.image}
                        alt={item.alt}
                        ratio={286 / 604}
                      />
                    </Link>
                  ))}
                </div>
              </GridCol>
              {props.listBanner.slice(3).map((item, key) => (
                <GridCol colSm={12} key={`${key}${item.image}`} colMd={6}>
                  <Link href={item.link}>
                    <Image src={item.image} alt={item.alt} ratio={286 / 604} />
                  </Link>
                </GridCol>
              ))}
            </>
          )}
        </GridRow>
      </Grid>
    </div>
  );
};

GridBannerPromotion.defaultProps = {};

export default GridBannerPromotion;
